module.exports = __webpack_public_path__ + "static/media/standartGlass.0020fc98.jpg";